var Field

window.Field = {}

Field = window.Field

Field.directiveConfig = (config, $injector) => {
  var $compile, $http, $templateCache, findInputElement, templateOuter, templatePath
  $compile = $injector.get("$compile")
  $http = $injector.get("$http")
  $templateCache = $injector.get("$templateCache")
  templatePath = "templates/inputs/"
  templateOuter = '<div class="controls"></div>'
  findInputElement = (element) => {
    var e
    e = element.find("input,textarea,select,datepicker,ui-select,.value")[0]
    return angular.element(e)
  }
  return {
    restrict: "E",
    priority: 700,
    terminal: true,
    require: "?^form",
    controller: config.controller,
    compile: (element, attrs) => {
      var getFieldElement, newElement, template
      if (config.preCompile) {
        config.preCompile(element, attrs)
      }
      newElement = angular.element(templateOuter)
      // element.removeAttr('size');
      template = config.template || config.type || attrs.template || "text"
      getFieldElement = $http
        .get(`${templatePath + template}.html`, {
          cache: $templateCache,
        })
        .then((response) => {
          var inputElement, respElement
          respElement = angular.element(response.data)
          newElement = respElement
          inputElement = findInputElement(newElement)
          angular.forEach(element[0].attributes, (attribute) => {
            var k, v
            v = attribute.value
            k = attribute.name
            if ("ng-if,ng-show,ng-hide".split(",").indexOf(k) !== -1) {
              newElement.attr(k, v)
              return true
            }
            if ("label,controller".split(",").indexOf(k) > -1) {
              return true
            }
            if (k !== "class") {
              return inputElement.attr(k, v)
            } else {
              return inputElement.addClass(v)
            }
          })
          return newElement
        })
      return (scope, element, attrs, formController) =>
        getFieldElement.then((newElement2) => {
          var childPlace, childScope, inputElement
          newElement = angular.copy(newElement2)
          childScope = scope.$new()
          inputElement = findInputElement(newElement)
          if (attrs.ngModel) {
            childScope.$modelId = attrs.ngModel.replace(".", "_").toLowerCase() + "_" + childScope.$id
            inputElement.attr("name", childScope.$modelId)
            inputElement.attr("id", childScope.$modelId)
            newElement.find("label").attr("for", childScope.$modelId)
          }
          childPlace = newElement.find("child")
          if (childPlace.length > 0) {
            childPlace.after(element.children())
            childPlace.remove()
          }
          if (config.postChildCompile) {
            config.postChildCompile(childScope, newElement)
          }
          $compile(newElement)(childScope, (clone) => element.after(clone))
          element.remove()
          if (formController) {
            childScope.$form = formController
            if (childScope.$modelId) {
              childScope.$field = formController[childScope.$modelId]
            }
          }
        })
    },
  }
}

angular
  .module("myApp")
  .directive("field", ($injector) => Field.directiveConfig({}, $injector))
  .directive("un2text", ($injector) =>
    Field.directiveConfig(
      {
        type: "text",
      },
      $injector
    )
  )
  .directive("un2number", ($injector) =>
    Field.directiveConfig(
      {
        type: "number",
      },
      $injector
    )
  )
  .directive("un2currency", ($injector) =>
    Field.directiveConfig(
      {
        type: "currency",
      },
      $injector
    )
  )
  .directive("un2textarea", ($injector) =>
    Field.directiveConfig(
      {
        type: "textarea",
      },
      $injector
    )
  )
  .directive("un2rich", ($injector) =>
    Field.directiveConfig(
      {
        type: "richtext",
      },
      $injector
    )
  )
  .directive("un2value", ($injector) =>
    Field.directiveConfig(
      {
        type: "value",
      },
      $injector
    )
  )
  .directive("un2checkbox", ($injector) =>
    Field.directiveConfig(
      {
        type: "checkbox",
      },
      $injector
    )
  )
  .directive("un2laiks", ($injector) =>
    Field.directiveConfig(
      {
        type: "laiks",
      },
      $injector
    )
  )
  .directive("un2email", ($injector) =>
    Field.directiveConfig(
      {
        type: "un2email",
      },
      $injector
    )
  )
  .directive("un2password", ($injector) =>
    Field.directiveConfig(
      {
        type: "un2password",
      },
      $injector
    )
  )
  .directive("un2cool", ($injector, $parse, uuiData) => {
    const config = {
      type: "typeahead",
      template: "un2cool",

      preCompile: (element, attrs) => {
        var getEntries, modelBase, typeahead
        modelBase = attrs.modelBase
        typeahead = attrs.typeahead
        if (attrs.getEntries) {
          getEntries = attrs.getEntries
        } else {
          getEntries = "$viewValue" + (attrs.params ? ", " + attrs.params : "")
        }
        typeahead = typeahead || "e as e.name for e in getEntries(" + getEntries + ")"
        attrs.uibTypeahead = typeahead
        element.attr("uib-typeahead", typeahead)
        element.removeAttr("typeahead")
        element.removeAttr("get-entries")
        element.removeAttr("params")
        if (attrs.tree) {
          element.attr("typeahead-template-url", "templates/inputs/tree-choice.html")
          element.removeAttr("tree")
          delete attrs.tree
        } else if (!attrs.typeaheadTemplateUrl) {
          element.attr("typeahead-template-url", "templates/inputs/choice.html")
        }
        if (element.attr("ng-model")) {
          return element.attr("ng-change", "hasValue = " + modelBase + "_name;")
        } else {
          element.attr("ng-model", modelBase + "_name")
          element.attr("ng-change", "clearValues()")
          if (!element.attr("typeahead-input-formatter")) {
            return element.attr("typeahead-input-formatter", "formatValue($model)")
          }
        }
      },

      postChildCompile: (scope, element) => {
        var _updateDefault, el, el2, selected
        el = element.find("input")
        scope.modelBase = el.attr("model-base")
        if (!scope.modelBase) {
          el2 = element.find(".dynamicUn2Cool")
          if (el2.attr("ng-model")) {
            scope.modelBase = el2.attr("ng-model").split("_name")[0]
          }
        }
        scope.df = $parse(scope.modelBase + "_name")
        scope.vf = $parse(scope.modelBase + "_id")
        scope.dis = $parse(scope.modelBase + "_name").assign
        scope.val = $parse(scope.modelBase + "_id").assign
        scope.hasValue = scope.df(scope)
        selected = null

        scope.clearValues = (clear) => {
          if (clear) {
            scope.hasValue = false
            scope.val(scope.$parent, null)
            return scope.dis(scope.$parent, null)
          } else {
            scope.hasValue = scope.df(scope)
            if (selected && scope.df(scope) !== selected.name) {
              selected = null
              return scope.val(scope.$parent, null)
            } else if (selected) {
              return scope.val(scope.$parent, selected[scope.id])
            } else {
              return scope.val(scope.$parent, null)
            }
          }
        }

        _updateDefault = (viewName, obj, base) => {
          var actual_value
          actual_value = scope[obj][base + "_id"]
          if (actual_value) {
            return uuiData.record(viewName, actual_value, scope.formatValue)
          }
        }

        scope.updateDefault = (viewName) => {
          var base, obj, pts
          if (!scope.modelBase) {
            return
          }
          pts = scope.modelBase.split(".", 2)
          obj = pts[0]
          base = pts[1]
          if (scope[obj] && scope[obj].$promise) {
            return scope[obj].$promise.then(() => _updateDefault(viewName, obj, base))
          } else {
            return _updateDefault(viewName, obj, base)
          }
        }

        scope.formatValue = (model) => {
          var pts
          scope.hasValue = model
          if (model && typeof model === "object") {
            pts = scope.modelBase.split(".", 2)
            _.each(model, (v, k) => {
              if (k[0] !== "$") {
                scope[pts[0]][pts[1] + "_" + k] = v
              }
            })
            selected = model
            return model.name
          } else {
            return model
          }
        }
      },
    }

    return Field.directiveConfig(config, $injector)
  })
